import React, { Component } from 'react';
import { connect } from 'react-redux';
import { update, UPDATE_FAIL } from 'app/redux/modules/auth';

import i18n from 'app/common/i18n';
import Alert from 'app/common/alert';
import Input from 'app/common/form/input';
import Button from 'app/common/button';

import Paper from '@mui/material/Paper';

import { toastr } from 'app/common/toastr';

@connect(() => ({}), { update })
@i18n
class ChangePassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,

      password: null,
      newPassword: null,
      newPassword2: null,
      response: null
    };
  }

  handleSubmit = (event) => {
    event.preventDefault();

    this.setState({ response: null });

    const { password, newPassword, newPassword2 } = this.state;

    if (!password) {
      toastr.error(
        this.props.i18n('Change password'),
        this.props.i18n('Type present password')
      );
      return this.setState({
        response: {
          type: 'danger',
          text: this.props.i18n('Type present password')
        }
      });
    }

    if (!newPassword || !newPassword2) {
      toastr.error(
        this.props.i18n('Change password'),
        this.props.i18n('Missing password')
      );
      return this.setState({
        response: { type: 'danger', text: this.props.i18n('Missing password') }
      });
    }

    if (newPassword !== newPassword2) {
      toastr.error(
        this.props.i18n('Change password'),
        this.props.i18n('New passwords do not match')
      );
      return this.setState({
        response: {
          type: 'danger',
          text: this.props.i18n('New passwords do not match')
        }
      });
    }

    this.props
      .update({ password: newPassword, oldPassword: password })
      .then((action) => {
        if (action.type === UPDATE_FAIL) {
          const { error: { response } = {} } = action || {};

          toastr.error(
            this.props.i18n('Change password'),
            this.props.i18n(response.message)
          );
          this.setState({
            response: {
              type: 'danger',
              text: this.props.i18n(response.message)
            }
          });
          return action;
        }
        toastr.success(
          this.props.i18n('Change password'),
          this.props.i18n('Your password has been changed')
        );
        this.setState({
          response: {
            type: 'success',
            text: this.props.i18n('Your password has been changed')
          }
        });
        return action;
      })
      .catch((err) => {
        if (__DEV__) {
          console.error(err);
        }
        toastr.error(
          this.props.i18n('Change password'),
          this.props.i18n(
            'Oops! Something went wrong. Please try again or contact customer support'
          )
        );
        this.setState({
          response: {
            type: 'danger',
            text: this.props.i18n(
              'Oops! Something went wrong. Please try again or contact customer support'
            )
          }
        });
      });
  };

  onChange = (ev) => {
    this.setState({ [ev.target.name]: ev.target.value, changed: true });
  };

  toggle = () => {
    const show = !this.state.show;
    this.setState({ show });
  };

  render() {
    const { show, response, changed } = this.state;

    if (!show) {
      return (
        <Button
          primary
          flat
          label={this.props.i18n('Change password')}
          onClick={this.toggle}
          style={{ margin: '8px 12px 12px 0' }}
        />
      );
    }

    return (
      <Paper
        component="form"
        onSubmit={this.handleSubmit}
        className="change-password"
        style={{ marginBottom: '1em', padding: '1em' }}
      >
        <legend
          style={{
            textTransform: 'uppercase',
            fontSize: '14px',
            marginBottom: '1em',
            marginTop: -1
          }}
        >
          {this.props.i18n('Change password')}
        </legend>

        <Input
          fullWidth
          name="password"
          onChange={this.onChange}
          required
          type="password"
          label={this.props.i18n('Current password')}
        />
        <Input
          fullWidth
          name="newPassword"
          onChange={this.onChange}
          required
          type="password"
          label={this.props.i18n('Desired password')}
          helperText={this.props.i18n(
            'At least 6 characters, digits or symbols'
          )}
        />
        <Input
          fullWidth
          name="newPassword2"
          onChange={this.onChange}
          required
          type="password"
          label={this.props.i18n('Desired password (again)')}
        />

        <br />
        {response ? <Alert type={response.type} text={response.text} /> : null}

        <div style={{ textAlign: 'right', paddingTop: '12px' }}>
          <Button
            flat
            secondary
            tabIndex={-1}
            label={this.props.i18n('Cancel')}
            onClick={this.toggle}
            style={{ float: 'left' }}
          />
          <Button
            primary
            variant="contained"
            type="submit"
            disabled={!changed}
            label={this.props.i18n('Change password')}
          />
        </div>
      </Paper>
    );
  }
}

export default ChangePassword;